import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './Projects.css';
import HighlightedTitle from '../components/HighlightedTitle';
import ProjectPage from '../components/ProjectPage';

function ArtProjects() {
  const [imageLoaded, setImageLoaded] = useState(
    new Array(1).fill(false) // Initialize an array for 1 project, all set to false (not loaded)
  );
  const [selectedProject, setSelectedProject] = useState(null);

  const projects = [
    {
      title: 'Memories and Moments',
      date: '2025',
      summary: 'A collection of prints capturing fleeting moments.',
      images: [
        { type: 'image', url: '/project_images/memories1.jpeg' },
        { type: 'video', url: "https://www.youtube.com/watch?v=WSP4N5vNup0" },
      ],
      placeholder: '/project_images/memories1.jpeg', // Optional placeholder
    },
    {
      title: 'After A Long Day',
      date: '2024',
      summary: 'A short video about a relationship.',
      images: [
        { type: 'image', url: '/project_images/stormking.png' },
        { type: 'video', url: "https://www.youtube.com/watch?v=nKCuCGDjblM" },
        { type: 'image', url: '/project_images/stormking2.png' },
        { type: 'image', url: '/project_images/stormking3.png' },
        { type: 'image', url: '/project_images/stormking4.png' },
        { type: 'image', url: '/project_images/stormking5.png' },
        // { type: 'image', url: '/project_images/stormking6.png' },
      ],
      placeholder: '/project_images/stormking.png', // Optional placeholder
    },
    {
      title: "Winter '24",
      date: '2024',
      summary: 'First snow.',
      images: [
        { type: 'image', url: '/project_images/winter.png' },
        { type: 'video', url: "https://www.youtube.com/watch?v=q6frBblMUhk" },
      ],
      placeholder: '/project_images/stormking.png', // Optional placeholder
    },
    
    {
      title: 'Watercolor Ritual',
      date: '2023',
      summary: 'A series of ritualistic watercolor paintings exploring themes of renewal.',
      images: [
        { type: 'image', url: '/project_images/watercolor.jpeg' },
        { type: 'image', url: '/project_images/watercolor2.jpeg' },
        { type: 'image', url: '/project_images/watercolor3.jpeg' },
        { type: 'image', url: '/project_images/watercolor4.jpeg' },
      ],
      placeholder: '/project_images/watercolor.jpeg', // Optional placeholder
    },

  ];

  const handleImageLoad = (index) => {
    setImageLoaded((prev) => {
      const newLoadedState = [...prev];
      newLoadedState[index] = true; // Mark image as loaded
      return newLoadedState;
    });
  };

  return (
    <AnimatePresence mode="wait">
      {selectedProject ? (
        <motion.div
          key="projectPage"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -50 }}
          transition={{ duration: 0.5 }}
        >
          <ProjectPage project={selectedProject} onBack={() => setSelectedProject(null)} />
        </motion.div>
      ) : (
        <motion.div
          key="projectList"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: 50 }}
          transition={{ duration: 0.5 }}
        >
          <div className="projects-container">
            {projects.map((project, index) => (
              <div
                key={index}
                className={`project-item ${index % 2 === 0 ? 'left-first' : 'right-first'}`}
                onClick={() => setSelectedProject(project)}
              >
                <div className="project-image">
                  <img
                    src={imageLoaded[index] ? project.images[0].url : project.placeholder} // Access the URL of the first image
                    alt={project.title}
                    className="project-image"
                    onLoad={() => handleImageLoad(index)} // Call handleImageLoad when image loads
                    loading="lazy" // Lazy load for better performance
                  />
                </div>
                <div className="project-text">
                  <div className="project-title">
                    <HighlightedTitle text={project.title} />
                    <p>{project.date}</p>
                  </div>
                  <p className='project-summary'>{project.summary}</p>
                </div>
              </div>
            ))}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default ArtProjects;